const initSlideshow = () => {
  const splideElement = document.getElementById('js-slider-mv')
  if (!splideElement) return

  new Splide(splideElement, {
    type: 'loop',
    focus: 'center',
    gap: 40,
    perPage: 1,
    perMove: 1,
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
    pagination: true,
    arrows: false,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 8,
      },
    },
  }).mount()
}

initSlideshow()

class ComingSoonChecker {
  constructor() {
    this.init()
  }

  init() {
    this.updateCurrentTime() // 現在時刻を更新
    this.checkAllComingSoonItems() // 初回チェック
  }

  updateCurrentTime() {
    const now = new Date()
    const jstTime = now
      .toLocaleString('ja-JP', {
        timeZone: 'Asia/Tokyo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
      .replace(/\//g, '-')

    const currentTimeJST = Math.floor(now.getTime() / 1000) + 9 * 60 * 60

    const timeElements = document.querySelectorAll('#current-time-jst')
    timeElements.forEach((el) => {
      el.textContent = jstTime
    })

    const timestampElements = document.querySelectorAll('#debug-timestamp')
    timestampElements.forEach((el) => {
      const startTime = document.querySelector('[data-start-time]')?.dataset
        .startTime
      if (startTime) {
        el.textContent = `${startTime} > ${currentTimeJST}`
      }
    })
  }

  checkAllComingSoonItems() {
    this.checkGridItems()
    this.checkProductButtons()
  }

  checkGridItems() {
    const comingSoonLabels = document.querySelectorAll(
      '.cr-label--coming-soon[data-start-time]',
    )

    comingSoonLabels.forEach((label) => {
      this.checkTimeAndUpdate(label, (element) => {
        const productCard = element.closest('.grid-view-item')
        if (productCard) {
          const hotLabel = productCard.querySelector(
            '.cr-label:not(.cr-label--coming-soon)',
          )
          if (hotLabel) {
            hotLabel.style.display = ''
          }
          element.remove()
        }
      })
    })
  }

  checkProductButtons() {
    const comingSoonMessages = document.querySelectorAll(
      '.coming-soon-button[data-start-time]',
    )

    comingSoonMessages.forEach((message) => {
      this.checkTimeAndUpdate(message, (element) => {
        element.style.display = 'none'

        const purchaseButtons = document.querySelector(
          '[data-purchase-buttons]',
        )
        if (purchaseButtons) {
          purchaseButtons.style.display = ''
        }
      })
    })
  }

  checkTimeAndUpdate(element, callback) {
    const startTimeStr = element.dataset.startTimeStr
    if (!startTimeStr) return

    const [datePart, timePart] = startTimeStr.split(' ')
    const [year, month, day] = datePart.split('-')
    const [hours, minutes, seconds] = timePart.split(':')

    const startTimeJST = new Date(
      Date.UTC(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day),
        parseInt(hours),
        parseInt(minutes),
        parseInt(seconds),
      ),
    )

    const now = new Date()
    const currentTimeJST = new Date(now.getTime() + 9 * 60 * 60 * 1000)

    const startTimeUnix = Math.floor(startTimeJST.getTime() / 1000)
    const currentTimeUnix = Math.floor(currentTimeJST.getTime() / 1000)

    if (currentTimeUnix < startTimeUnix) {
      return
    }

    callback(element)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ComingSoonChecker()
})
